// Google Drive integration commands
// These commands are dynamically added to the tool list when Google Drive files are in context

import { googleDocReadCommand } from './google_doc_read';
import { googleDocWriteCommand } from './google_doc_write';
import { googleSheetReadCommand } from './google_sheet_read';
import { googleSheetWriteCommand } from './google_sheet_write';

// Export all Google Drive commands
export const googleDriveCommands: any[] = [
  googleDocReadCommand,
  googleDocWriteCommand,
  googleSheetReadCommand,
  googleSheetWriteCommand
];



